export default {"src":"/_next/static/media/tick-green.6ff69a4d.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};